import { render } from "./StatusTarefaBacklog.vue?vue&type=template&id=7fc602b9&scoped=true"
import script from "./StatusTarefaBacklog.vue?vue&type=script&lang=js"
export * from "./StatusTarefaBacklog.vue?vue&type=script&lang=js"

import "./StatusTarefaBacklog.vue?vue&type=style&index=0&id=7fc602b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc602b9"]])

export default __exports__